window._ = require( 'lodash' );
window.axios = require( 'axios' );
window.moment = require( 'moment' );

import "../../../node_modules/bootstrap/js/button.js";